<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row" v-if="$permissions.hasRight('dashboard.learners.read')">
                <div class="col-lg-6 order-lg-2">
                    <registration :registration="registration"></registration>
                    <simulations :registration="registration" :simulations="simulations"></simulations>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <groups :registration="registration" :groups="groups" :learners="learners"></groups>
                    <learners :registration="registration" :learners="learners"></learners>
                </div>
            </div>

            <div class="row" v-else>
                <div class="col-lg-12">
                    <registration :registration="registration"></registration>
                    <simulations :registration="registration" :simulations="simulations"></simulations>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Learners from './cohort/RegistrationLearners'
    import Registration from './cohort/Registration';
    import Simulations from './cohort/Simulations';
    import Groups from './cohort/GroupsCrud';

    export default {

        components: {
            Learners, Registration, Simulations, Groups
        },

        data() {
            return {
                registration: null,
                simulations: null,
                learners: null,
                groups: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.$route.params.cohortId
                    },
                    {
                        name: this.registration.degree.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/cohorts/'+to.params.cohortId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.learners = resp.data.included.learners
                    vm.groups = resp.data.included.groups
                    vm.simulations = resp.data.included.simulations
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
